import { orpc } from "@/utils/orpc.client";
import type { Filter } from "@garimpa/lib/facetFilter";

interface WorkReleasesQueryOptionsInput {
  id: string;
  /** Internal facet filter tree built from the flat URL filter contract. */
  filter?: Filter;
  search?: string | null;
  sort?: string;
  page?: number;
}

export const WORK_RELEASE_PAGE_SIZE = 9;

export function searchWorkReleasesQueryOptions(input: WorkReleasesQueryOptionsInput) {
  const page = Math.max(1, input.page ?? 1);

  return orpc.music.searchWorkReleases.queryOptions({
    input: {
      id: input.id,
      filter: input.filter?.length ? input.filter : undefined,
      search: input.search ?? undefined,
      sort: input.sort ?? "date-desc",
      limit: WORK_RELEASE_PAGE_SIZE,
      offset: (page - 1) * WORK_RELEASE_PAGE_SIZE,
    },
  });
}
